export default __webpack_public_path__ + "static/media/notify_icon.1eefd77c.svg";